export default {"src":"/_next/static/media/gradient_products.f884372b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};